import { IconProps } from "./";
import Icon from "./assets/mic_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Mic(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
